// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Automatik')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

import { compile, registerLicense } from '@syncfusion/ej2-base'
import { QueryBuilder } from '@syncfusion/ej2-querybuilder';
import { CheckBoxSelection, DropDownList, MultiSelect } from '@syncfusion/ej2-dropdowns';
import { TextBox } from '@syncfusion/ej2-inputs'
import { DatePicker } from '@syncfusion/ej2-calendars'
import { getComponent, loadCldr, setCulture, setCurrencyCode } from '@syncfusion/ej2-base';

registerLicense('ORg4AjUWIQA/Gnt2VFhhQlJDfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5QdExiXHpfcHZRRGdf')
window.QueryBuilder = QueryBuilder
window.EJ2 = {
  compile: compile,
  loadCldr: loadCldr,
  setCulture: setCulture,
  setCurrencyCode: setCurrencyCode,
  CheckBoxSelection: CheckBoxSelection,
  DatePicker: DatePicker,
  DropDownList: DropDownList,
  MultiSelect: MultiSelect,
  TextBox: TextBox,
}

window.getComponent = getComponent
